// import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const Btn = styled.button.attrs((props) => ({
  type: props.button ? "button" : "submit",
}))`
  /* width: 100%; */
  background-color: ${(props) => props.theme.colors.bg.color1};
  color: ${(props) => props.theme.colors.txt.color6};
  /* border: 1px solid ${(props) => props.theme.colors.colorbg}; */
  border: none;
  border-radius: 3px;
  /* font-size: clamp(0.7rem, 1.2vw, 1.5rem); */
  font-size: 1rem;
  font-family: inherit;
  transition: 0.2s;
  /* padding: 0.75rem; */
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    font-weight: 900;
    background-color: ${(props) => props.theme.colors.bg.color2};
    /* color: ${(props) => props.theme.colors.colortxt}; */
  }
`;

export const Main = styled(Btn)`
  width: ${(props) => (props.small ? "fit-content" : "100%")};
  padding: 10px 18px;
  margin-top: 1rem;
  font-weight: 600;
`;

export const CardButton = styled.button`
  background-color: transparent;
  width: ${(props) => (props.small ? "50px" : "100%")};
  color: ${(props) => props.theme.colors.txt.color1};
  padding: 3px 5px;
  /* margin-top: 1rem; */
  font-weight: 600;

  border: 1px solid ${(props) => props.theme.colors.bg.color1};
  border-radius: 3px;
  /* font-size: clamp(0.7rem, 1.2vw, 1.5rem); */
  /* font-size: 1rem; */
  font-family: inherit;
  transition: 0.2s;
  /* padding: 0.75rem; */
  /* text-transform: uppercase; */
  cursor: pointer;

  &:hover {
    font-weight: 900;
    background-color: ${(props) => props.theme.colors.bg.color2};
    color: ${(props) => props.theme.colors.txt.color4};
  }
`;
